export default "__VITE_ASSET__DJS6VY_W__"